import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import {FormGroup, FormBuilder} from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { SharedService } from '../../shared/shared.service';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SettingsPlannerService} from "./settings-planner.service";
import {DtoAppointmentLabel} from "./models/DtoAppointmentLabel";

@Component({
    selector: 'appointmentlabel',
    template: require('./appointmentlabel.component.html'),
    styles: [require('./appointmentlabel.component.css')]
})
@AutoUnsubscribe()

export class AppointmentlabelComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoAppointmentLabel;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsPlannerService,
                private ss: SharedService) { }

    ngOnInit() {
        this.form = this.fb.group({
            displayName: [null, [SharedValidators.customRequired]],
            color: [null,[SharedValidators.customRequired]],
            isActive: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getAppointmentLabelById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.dtoObject.color = this.ss.removeColorAlpha(this.dtoObject.color);
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.ds.getAppoinmentLabelNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        isActive: true,
                        labelId: res
                    };
                    if (this.copyFromId > 0) {
                        this.ds.getAppointmentLabelById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.color = this.ss.removeColorAlpha(response.color);
                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getColor(): string {
        if (this.form && this.form.get('color').value)
            return this.form.get('color').value;
        else
            return '#ffffff';
    }

    onColorPickerChange(colorCode: string) {
        this.form.patchValue({ color: colorCode });
        this.form.markAsDirty();
        this.form.markAsTouched();
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveAppointmentLabel(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-planner/appointmentlabel.component.ts